import { render } from "./RulesEditor.vue?vue&type=template&id=56efdd9e&scoped=true&ts=true"
import script from "./RulesEditor.vue?vue&type=script&lang=ts"
export * from "./RulesEditor.vue?vue&type=script&lang=ts"

import "./RulesEditor.vue?vue&type=style&index=0&id=56efdd9e&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56efdd9e"]])

export default __exports__